import { render } from "./DetailsReportDemo.vue?vue&type=template&id=419da04c&scoped=true&lang=pug"
import script from "./DetailsReportDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsReportDemo.vue?vue&type=script&setup=true&lang=js"

import "./DetailsReportDemo.vue?vue&type=style&index=0&id=419da04c&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419da04c"]])

export default __exports__